import React from 'react';
import PropTypes from 'prop-types';
import './ProTip.scss';

function ProTip(props) {
  let iconClassName = 'fas fa-magic';
  let headingText = 'ProTip';
  let backgroundColor = 'yellow';
  if (props.isExample) {
    iconClassName = 'fas fa-paperclip';
    headingText = 'Examples';
    backgroundColor = 'blue';
  }
  return (
    <div className={`sticky-note ${backgroundColor} ${props.className}`}>
      <div className="heading mb-2">
        <i className={iconClassName} />
        {headingText}
      </div>
      {props.children}
    </div>
  );
}

ProTip.propTypes = {
  isExample: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ProTip.defaultProps = {
  isExample: false,
  className: '',
};

export default ProTip;
